import React, { useCallback, useMemo, useRef, useState } from "react";
import { useEndpointHook } from "../../../hooks/useEndpointHook";
import { useDispatch, useSelector } from "react-redux";
import { financingRequestsClear } from "../../../redux/reducers/financingRequestsReducer";
import Flx from "../../layout/Flx";
import FileUploadFieldWithModal from "../../common/FileUploadFieldWithModal";
import { amber, grey, orange, red, yellow } from "@mui/material/colors";
import { Box, Button } from "@mui/material";
import BasicFilesTable from "../../tables/BasicFilesTable";
import FilterTabSwitcher from "../../../_src_shared/components/navigation/FilterTabSwitcher";
import {
  ArrowUpwardOutlined,
  AttachFileOutlined,
  CloseRounded,
  EditOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  ViewModuleOutlined,
} from "@mui/icons-material";
import InputWrapper from "../../inputs/shared/InputWrapper";
import SelectFileAssignmentInput from "../../../_src_shared/components/inputs/SelectFileAssignmentInput";
import { isEmpty, size } from "lodash";
import AgGridTableWrapper from "../../agGrid/AgGridTableWrapper";
import { AgGridReact } from "ag-grid-react";
import Txt from "../../typography/Txt";
import FileUploadField from "../../inputs/FileUploadField";
import FlxGrid from "../../../_src_shared/components/layout/FlxGrid";
import { useFileDocGroupAndTypesHook } from "../../../_src_shared/hooks/useFileDocGroupAndTypesHook";
import SearchInput from "../../inputs/SearchInput";

const FinancingRequestFilesTab = ({ dealId, loanDocuments }) => {
  return (
    <Flx column g={1.5}>
      <FileUploadProcess dealId={dealId} loanDocuments={loanDocuments} />
      {/* <FileUploadFieldWithModal
        suppressUploadButton
        borderSize={1.5}
        minHeight={"88px"}
        keyName={`file-uploader-card-${dealId}`}
        onSubmit={handleOnSubmit}
        loading={loading}
        inputSx={{ background: grey[50] }}
        files={uploadedFiles}
        setFiles={setUploadedFiles}
      /> */}

      <Box
        sx={{
          maxHeight: "800px",
          overflowY: "auto",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: "8px",
          ".ag-row-last": {
            borderBottom: "none !important",
          },
          ".ag-header-viewport": {
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          },
        }}
      >
        <BasicFilesTable
          headerHeight={50}
          showStatus
          showUploadDate
          files={loanDocuments}
        />
      </Box>
    </Flx>
  );
};

const UPLOAD_TYPES = {
  QUICK_UPLOAD: "quick_upload",
  GROUP: "group",
};

const FileUploadProcess = ({ loanDocuments, dealId }) => {
  const [uploadType, setUploadType] = useState(UPLOAD_TYPES.QUICK_UPLOAD);

  return (
    <>
      <Flx fw jb ac wrap g={1}>
        <Flx column>
          <Txt bold fontSize={16}>
            Uploaded Loan Documents ({size(loanDocuments)})
          </Txt>
          <Txt secondary>
            Documents uploaded here will be visible to lenders once your
            financing request is submitted.
          </Txt>
        </Flx>
        <FilterTabSwitcher
          fontSize={11}
          value={uploadType}
          sx={{
            background: "#f2f1ef",
            border: "1px solid #e5e3df",
            // borderRadius: "4px",
          }}
          onChange={setUploadType}
          tabs={[
            {
              label: "Quick Upload",
              value: UPLOAD_TYPES.QUICK_UPLOAD,
              icon: <ArrowUpwardOutlined />,
            },
            {
              label: "Upload By Category",
              value: UPLOAD_TYPES.GROUP,
              icon: <ViewModuleOutlined />,
            },
          ]}
        />
      </Flx>
      <LoanDocumentUploaderProcess
        view={uploadType}
        dealId={dealId}
        setUploadType={setUploadType}
      />
    </>
  );
};

const LoanDocumentUploaderProcess = ({ view, dealId, setUploadType }) => {
  const [addedFiles, setAddedFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const { loading, uploadFilesToLoan, getBorrowerFinancingApplications } =
    useEndpointHook();

  const [editing, setEditing] = useState(false);

  const onFilesAdded = useCallback((newFiles) => {
    setAddedFiles((prev) => [...prev, ...newFiles]);
  }, []);

  const onDocGroupTypeChange = useCallback(
    (p) => {
      const { docGroup, docType } = p || {};
      console.log("docGroup, docType", docGroup, docType);
      if (!docGroup && !docType) return;
      console.log("addedFiles", addedFiles);
      console.log("selectedFiles", { selectedFiles, addedFiles });
      // selectedFiles should be an array of keys (or ids)
      const selectedSet = new Set(selectedFiles.map((f) => f.id));

      const updated = addedFiles.map((file) => {
        const key = file?.id;

        if (!selectedSet.has(key)) return file;
        return {
          ...file,
          docGroup,
          docType,
        };
      });
      console.log("updated files with new docGroup/docType", updated);
      setAddedFiles(updated);

      // close editing UI after applying change (matches your current intent)
      setSelectedFiles([]);
      setEditing(false);
    },
    [addedFiles, selectedFiles],
  );

  const handleUploadFiles = () => {
    uploadFilesToLoan({
      dealId: dealId,
      files: addedFiles,
      onSuccessFn: () => {
        getBorrowerFinancingApplications({
          onSuccessFn: () => {
            setSelectedFiles([]);
            setAddedFiles([]);
            setUploadType(UPLOAD_TYPES.QUICK_UPLOAD);
          },
        });

        // dispatch(financingRequestsClear());
      },
    });
  };

  const border = `1px solid ${grey[300]}`;
  const onRemoveFile = useCallback((fileId) => {
    setAddedFiles((prev) => prev.filter((f) => f.id !== fileId));
  }, []);

  return (
    <Flx
      // g={4}
      // wrap
      column
      sx={{
        // overflow: "visible",
        position: "relative",
        // background: "red",
        border: isEmpty(addedFiles) ? "none" : border,
        boxShadow: isEmpty(addedFiles) ? "none" : `0 2px 4px ${grey[200]}`,
        // borderTop: isEmpty(addedFiles) ? "none" : border,
        // borderRight: isEmpty(addedFiles) ? "none" : border,
        // borderLeft: isEmpty(addedFiles) ? "none" : border,
        // borderBottom: border,
        p: isEmpty(addedFiles) ? 0 : 2,
        borderRadius: isEmpty(addedFiles) ? 0 : 4,
        pb: 2,
        // pb: 5,
        mb: isEmpty(addedFiles) ? 0 : 5,
      }}
    >
      {view === UPLOAD_TYPES.QUICK_UPLOAD && (
        <FileUploadField
          key={""}
          onFilesAdded={onFilesAdded}
          suppressGrid
          borderSize={2}
          background={"#ffffff"}
          suppressFileList
          minHeight={"120px"}
          suppressUploadButton
        />
      )}
      {view === UPLOAD_TYPES.GROUP && (
        <UploadLoanDocumentByGroupProcess
          addedFiles={addedFiles}
          onFilesAdded={onFilesAdded}
          onRemoveFile={onRemoveFile}
        />
      )}

      {!isEmpty(addedFiles) && (
        <>
          <Flx
            column
            g={1}
            sx={{
              // background: grey[100],
              background: `#fbedd647`,
              // background: orange[50],
              // background: "#f2f1ef9e",
              border: `1px solid ${orange[100]}`,
              // border: "2px solid #eeeeee",
              px: 2,
              borderRadius: 2,
              mt: 4,
              pt: 2,
              pb: 2,
              zIndex: 111,
              height: "unset",
            }}
          >
            <Flx
              column
              sx={
                {
                  // background: "#f2f1ef",
                  // p: 2,
                  // border: "1px solid #e5e3df",
                  // borderBottom: 0,
                  // borderTopRightRadius: "8px",
                  // borderTopLeftRadius: "8px",
                }
              }
            >
              <Txt sx={{ fontWeight: 500 }} fontSize={14}>
                Review Pending Files ({size(addedFiles)})
              </Txt>
              <Txt secondary>
                Review the following files before uploading. Click on any added
                file below to edit its name
              </Txt>
            </Flx>
            <Flx column g={2.5} sx={{ mb: 1 }}>
              <UploadedFilesTable
                editing={editing}
                files={addedFiles}
                setFiles={setAddedFiles}
                setSelectedFiles={setSelectedFiles}
              />
              {editing && !isEmpty(selectedFiles) && (
                <InputWrapper sx={{ mb: 2 }} label={"Select Document Type"}>
                  <SelectFileAssignmentInput onChange={onDocGroupTypeChange} />
                </InputWrapper>
              )}
            </Flx>
            <Flx
              g={1}
              fw
              ac
              wrap
              jb
              sx={{
                mt: 2,
              }}
            >
              <Button
                onClick={() => setAddedFiles([])}
                variant="outlined"
                // sx={{ flexGrow: 1 }}
                size="large"
                color="error"
              >
                Clear All
              </Button>
              <Button
                // sx={{ flexGrow: 1 }}
                loading={loading}
                onClick={() => handleUploadFiles(addedFiles)}
                size="large"
                color="primary"
              >
                Upload Files ({size(addedFiles)})
              </Button>
              {/* <Flx g={1} fw ac end wrap>
                <Button
                  sx={{ flexGrow: 1 }}
                  onClick={() => setEditing((s) => !s)}
                  variant="outlined"
                  size="large"
                  color="gray"
                >
                  {editing ? "Cancel Editing" : "Edit Document Types"}
                </Button>
                <Button
                  sx={{ flexGrow: 1 }}
                  loading={loading}
                  onClick={() => handleUploadFiles(addedFiles)}
                  size="large"
                  color="primary"
                >
                  Upload Files ({size(addedFiles)})
                </Button>
              </Flx> */}
            </Flx>
          </Flx>
        </>
      )}
    </Flx>
  );
};

const UploadedFilesTable = ({ files, setFiles, setSelectedFiles, editing }) => {
  const ref = useRef();
  const modalContentRef = useRef(null);

  const groupRows = useMemo(() => {
    const uniqueGroups = new Set(files.map((f) => f.docGroup));
    return uniqueGroups.size > 1;
  }, [files]);

  const handleToggleParse = useCallback(
    (id, checked) => {
      setFiles((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, parse: checked } : item,
        ),
      );

      setTimeout(() => {
        if (ref.current?.api) {
          ref.current.api.refreshCells();
        }
      }, 0);
    },
    [setFiles],
  );

  const columnDefs = useMemo(
    () => [
      {
        resizable: false,
        cellRenderer: () => {
          return <AttachFileOutlined className="thin" sx={{ fontSize: 22 }} />;
        },
        maxWidth: 32,
        cellStyle: {
          paddingLeft: 0,
          paddingRight: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      },
      {
        headerName: "Filename",
        field: "file_display_name",
        flex: 1,
        minWidth: 150,
        // tooltipValueGetter: (p) => {
        //   return `Rename ${p?.data?.file_display_name}`;
        // },
        cellEditor: "agTextCellEditor",
        editable: true,
        cellRenderer: (params) => {
          return (
            <Flx fw jb ac>
              <Flx column>
                <Txt fontSize={12}>{params.value}</Txt>
                {!params?.data?.docGroup || !params?.data?.docType ? null : (
                  <Txt className="thin" secondary sx={{ fontSize: 10 }}>
                    {params?.data?.docType}
                  </Txt>
                )}
              </Flx>
              <EditOutlined className="thin" color="grey" />
            </Flx>
          );
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
          cursor: "text",
          gap: "6px",
          paddingLeft: "0px",
        },
      },
      {
        field: "docGroup",
        rowGroup: groupRows,
        hide: true,
        valueGetter: (params) => {
          return params?.data?.docGroup || "Uncategorized";
        },
      },

      {
        width: 38,
        headerName: "",
        pinned: "right",
        cellStyle: {
          paddingRight: 0,
          paddingLeft: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        },
        field: "delete",
        cellRenderer: () => {
          return <CloseRounded className="thin" color="error" />;
        },
      },
    ],
    [groupRows, handleToggleParse],
  );

  const handleCellValueChanged = useCallback(
    (params) => {
      const { colDef, data, newValue } = params;
      const updatedData = { ...data };

      if (colDef.field === "file_display_name") {
        const originalExtension = data.name.split(".").pop().toLowerCase();
        const newValueWithoutExt = newValue.replace(/\.[^/.]+$/, "");
        updatedData.file_display_name = `${newValueWithoutExt}.${originalExtension}`;
      }

      if (colDef.field === "docGroup") {
        updatedData.docGroup = newValue;
        updatedData.docType = "";
      }

      if (colDef.field === "docType") {
        updatedData.docType = newValue;
      }

      setFiles((prev) =>
        prev.map((item) => (item.id === data.id ? updatedData : item)),
      );

      setTimeout(() => {
        if (ref.current?.api) {
          ref.current.api.refreshCells();
        }
      }, 0);
    },
    [setFiles],
  );

  // const rowSelection = useMemo(() => {
  //   if (editing) {
  //     return { mode: "multiRow" };
  //   }

  //   return {};
  // }, [editing]);

  const onCellClicked = useCallback(
    (params) => {
      const { colDef, data } = params;

      if (colDef.field === "delete") {
        setFiles((prev) => prev.filter((item) => item.id !== data.id));
        return;
      }

      if (colDef.field === "parse" && !params.node.group) {
        setFiles((prev) =>
          prev.map((item) =>
            item.id === data.id ? { ...item, parse: !item.parse } : item,
          ),
        );

        setTimeout(() => {
          if (ref.current?.api) {
            ref.current.api.refreshCells({
              rowNodes: [params.node],
              columns: ["parse"],
            });
          }
        }, 0);
      }
    },
    [setFiles],
  );

  const handleRowSelectionChange = useCallback(
    (params) => {
      const selected = params.api.getSelectedRows();
      setSelectedFiles(selected);
    },
    [setSelectedFiles],
  );

  const onRowClicked = useCallback((params) => {
    if (params.node.group) {
      params.node.setExpanded(!params.node.expanded);
    }
  }, []);

  const getRowStyle = useCallback((params) => {
    if (params.node.group) {
      return {
        fontWeight: 600,
        fontStyle: "italic",
        fontSize: "13px",
        cursor: "pointer",
      };
    }

    return undefined;
  }, []);

  if (!files?.length) {
    return null;
  }

  return (
    <Box
      sx={{
        border: "1px solid #e5e3df",
        // border: "1px solid #eeeeee",
        overflow: "hidden",
        borderRadius: "8px",
        // borderTopRightRadius: 0,
        // borderTopLeftRadius: 0,
        ".ag-header": {
          border: "none !important",
        },
        ".ag-pinned-right-cols-container .ag-cell": {
          borderLeft: "1px solid #eeeeee !important",
        },
        ".ag-row-last": {
          borderBottom: "none !important",
        },
      }}
    >
      <AgGridTableWrapper simpleTable suppressMinHeightWhenPopulated={files}>
        <div ref={modalContentRef}>
          <AgGridReact
            ref={ref}
            rowData={files}
            columnDefs={columnDefs}
            singleClickEdit
            rowHeight={54}
            onCellClicked={onCellClicked}
            domLayout="autoHeight"
            // tooltipShowDelay={100}
            // tooltipMouseTrack
            headerHeight={0}
            getRowStyle={getRowStyle}
            onRowClicked={onRowClicked}
            // rowSelection={rowSelection}
            onSelectionChanged={handleRowSelectionChange}
            groupDisplayType="groupRows"
            groupDefaultExpanded={groupRows ? 1 : -1}
            onCellValueChanged={handleCellValueChanged}
            stopEditingWhenCellsLoseFocus
            popupParent={modalContentRef.current}
          />
        </div>
      </AgGridTableWrapper>
    </Box>
  );
};

const UploadLoanDocumentByGroupProcess = ({
  addedFiles,
  onFilesAdded,
  onRemoveFile,
}) => {
  const { fileDocGroups, getDocTypesByGroup } = useFileDocGroupAndTypesHook({
    showAllDocTypes: true,
    showBorrowerDocTypes: true,
  });

  const [search, setSearch] = useState("");

  const [openGroups, setOpenGroups] = useState(new Set());

  const filteredGroups = useMemo(() => {
    if (!search?.trim()) return fileDocGroups;
    const lower = search.toLowerCase();
    return fileDocGroups.filter((gr) =>
      getDocTypesByGroup(gr)?.some((dt) => dt.toLowerCase().includes(lower)),
    );
  }, [fileDocGroups, search, getDocTypesByGroup]);

  const allExpanded = filteredGroups.every((gr) => openGroups.has(gr));

  const handleExpandAll = () => setOpenGroups(new Set(filteredGroups));
  const handleCollapseAll = () => setOpenGroups(new Set());

  return (
    <Flx column g={1}>
      <Flx
        ac
        jb
        fw
        wrap
        g={1}
        // sx={{ position: "sticky", top: 0, left: 0, zIndex: 11 }}
      >
        <SearchInput
          sx={{ mr: 3, width: "100%", maxWidth: "280px" }}
          value={search}
          placeholder="Search for a document type..."
          onChange={setSearch}
        />
        <Flx ac g={1}>
          <Button
            size="small"
            startIcon={<KeyboardArrowUp fontSize="small" sx={{ mr: -0.5 }} />}
            variant="text"
            // variant="outlined"
            color="gray"
            onClick={handleExpandAll}
            sx={{ whiteSpace: "nowrap", flexShrink: 0, fontWeight: 400 }}
          >
            Open All Groups
          </Button>
          <Button
            size="small"
            variant="text"
            // variant="outlined"
            color="gray"
            startIcon={<KeyboardArrowDown fontSize="small" sx={{ mr: -0.5 }} />}
            onClick={handleCollapseAll}
            sx={{
              whiteSpace: "nowrap",
              flexShrink: 1,
              fontWeight: 400,
            }}
          >
            Close All Groups
          </Button>
        </Flx>
      </Flx>
      {/* <FlxGrid width="260px"> */}
      <FlxGrid width="310px">
        {isEmpty(filteredGroups) && (
          <Txt sx={{ fontStyle: "italic", p: 1 }}>No document types found.</Txt>
        )}
        {filteredGroups.map((gr) => (
          <DocGroupUpload
            key={gr}
            add
            docGroup={gr}
            search={search}
            addedFiles={addedFiles}
            isOpen={openGroups.has(gr)}
            onToggle={(group) =>
              setOpenGroups((prev) => {
                const next = new Set(prev);
                next.has(group) ? next.delete(group) : next.add(group);
                return next;
              })
            }
            onFilesAdded={onFilesAdded}
            onRemoveFile={onRemoveFile}
          />
        ))}
      </FlxGrid>
    </Flx>
  );
};
// DocGroupUpload — pass addedFiles and onRemoveFile to DocTypeUploadList

const DocGroupUpload = ({
  docGroup,
  onFilesAdded,
  onRemoveFile,
  addedFiles,
  search,
  isOpen,
  onToggle,
}) => {
  const isSearching = !!search?.trim();
  const expanded = isSearching || isOpen;

  const filteredGroupCount = size(
    addedFiles?.filter((f) => f?.docGroup === docGroup),
  );
  return (
    <Flx
      column
      sx={{
        bgcolor: "#f2f1ef",
        border: "1px solid #e5e3df",
        borderRadius: 1,
        height: "max-content",
      }}
    >
      <Box
        onClick={() => onToggle(docGroup)}
        sx={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 1,
          justifyContent: "space-between",
          p: 1,
        }}
      >
        <Txt
          sx={{ fontSize: "11.5px", fontWeight: 500 }}
        >{`${docGroup} ${filteredGroupCount > 0 ? `(${filteredGroupCount})` : ""}`}</Txt>
        {expanded ? (
          <KeyboardArrowUp fontSize="small" />
        ) : (
          <KeyboardArrowDown fontSize="small" />
        )}
      </Box>
      <DocTypeUploadList
        docGroup={docGroup}
        show={expanded}
        search={search}
        onFilesAdded={onFilesAdded}
        addedFiles={addedFiles}
        onRemoveFile={onRemoveFile}
      />
    </Flx>
  );
};

// DocTypeUploadList — show files under each docType

const DocTypeUploadList = ({
  docGroup,
  onFilesAdded,
  onRemoveFile,
  show,
  search,
  addedFiles,
}) => {
  const { getDocTypesByGroup, formatDocTypeLabel } =
    useFileDocGroupAndTypesHook({
      showAllDocTypes: true,
    });

  const docTypes = getDocTypesByGroup(docGroup) || [];

  const filteredDocTypes = useMemo(() => {
    if (!search?.trim()) return docTypes;
    return docTypes.filter((dt) =>
      dt.toLowerCase().includes(search.toLowerCase()),
    );
  }, [docTypes, search]);

  const minHeight = useMemo(() => {
    return "58px";
    // return "44px";
  }, [docTypes]);

  const gridWidth = useMemo(() => {
    // return "185px";
    return "155px";
  }, [docTypes]);

  // Group addedFiles by docType for quick lookup
  const filesByDocType = useMemo(() => {
    const map = {};
    addedFiles?.forEach((f) => {
      if (f?.docGroup === docGroup && f?.docType) {
        if (!map[f.docType]) map[f.docType] = [];
        map[f.docType].push(f);
      }
    });
    return map;
  }, [addedFiles, docGroup]);

  return (
    <Box sx={{ overflow: "hidden", height: show ? "auto" : 0 }}>
      <FlxGrid
        width={gridWidth}
        sx={{
          p: 1,
          borderTop: "1px solid #e5e3df",
          ".upload-text-label": {
            fontSize: "11.5px",
            // fontSize: "10.5px",
            opacity: 1,
            // letterSpacing: "-.2px",
          },
          ".file-upload-field": {
            py: 1.1,
          },
        }}
      >
        {filteredDocTypes.map((dt) => {
          const dtFiles = filesByDocType[dt] || [];
          return (
            <Flx
              key={dt}
              column
              sx={{
                ".file-upload-field": {
                  // borderBottomStyle: size(dtFiles) >= 1 ? "solid" : "dashed",
                  borderBottomWidth: size(dtFiles) >= 1 ? 0 : 2,
                },
              }}
            >
              <FileUploadField
                onFilesAdded={(f) => onFilesAdded(f, docGroup, dt)}
                suppressGrid
                hideUploadButton
                docType={dt}
                borderSize={2}
                docGroup={docGroup}
                background={"#ffffff"}
                suppressFileList
                minHeight={minHeight}
                uploadText={formatDocTypeLabel(dt)}
                suppressUploadButton
              />
              {dtFiles.length > 0 && (
                <Flx
                  column
                  sx={{
                    // mt: 0.5,
                    mb: 0.5,
                    gap: 0.25,
                    bgcolor: "#fff",
                    // border: "1px solid #e5e3df",
                    border: "1px solid #e0e0e0",
                    borderTop: "1px solid #e0e0e094",

                    // mt: "-2px",
                    // mx: 0.6,
                    // borderRadius: "8px",
                    // borderTop: "none",
                    borderBottomLeftRadius: "6px",
                    borderBottomRightRadius: "6px",
                  }}
                >
                  {dtFiles.map((file) => (
                    <Flx
                      key={file.id}
                      ac
                      jb
                      sx={{
                        borderRadius: 0.5,
                        px: 0.5,
                        py: 0.75,
                        gap: 0.5,
                      }}
                    >
                      <Flx ac g={0.5} sx={{ overflow: "hidden", minWidth: 0 }}>
                        <AttachFileOutlined
                          sx={{ fontSize: 12, color: grey[500], flexShrink: 0 }}
                        />
                        <Txt
                          sx={{
                            fontSize: "10px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontStyle: "italic",
                          }}
                        >
                          {file.file_display_name || file.name}
                        </Txt>
                      </Flx>
                      <CloseRounded
                        onClick={(e) => {
                          e.stopPropagation();
                          onRemoveFile(file.id);
                        }}
                        sx={{
                          fontSize: 14,
                          color: red[600],
                          cursor: "pointer",
                          flexShrink: 0,
                          "&:hover": { color: "error.main" },
                        }}
                      />
                    </Flx>
                  ))}
                </Flx>
              )}
            </Flx>
          );
        })}
      </FlxGrid>
    </Box>
  );
};
export default FinancingRequestFilesTab;
